(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const initialize = () => {
    const navigation = document.getElementById('navBar');
    const toggle = document.querySelector('[data-sc-menu-toggle]');
    const bar = document.getElementById('mobileNavBar');
    if (!navigation || !toggle || !bar || toggle.dataset.scMenuReady) return;
    toggle.dataset.scMenuReady = 'true';
    const mobile = window.matchMedia('(max-width: 768px)');
    const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
    const position = () => {
      navigation.style.setProperty('--sc-menu-top', Math.max(0, bar.getBoundingClientRect().bottom) + 'px');
    };
    const close = (returnFocus = false) => {
      toggle.setAttribute('aria-expanded', 'false');
      navigation.removeAttribute('data-sc-menu-open');
      if (returnFocus) toggle.focus();
    };
    toggle.addEventListener('click', () => {
      if (!mobile.matches) return;
      if (isOpen()) {
        close();
      } else {
        position();
        toggle.setAttribute('aria-expanded', 'true');
        navigation.setAttribute('data-sc-menu-open', '');
        requestAnimationFrame(() => navigation.querySelector('input:not([type=hidden]), a[href], button:not([disabled]), summary')?.focus());
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && isOpen()) {
        event.preventDefault();
        close(true);
      }
    });
    document.addEventListener('click', event => {
      if (isOpen() && !navigation.contains(event.target) && !toggle.contains(event.target)) close();
    });
    document.addEventListener('focusin', event => {
      if (isOpen() && !navigation.contains(event.target) && !toggle.contains(event.target)) close();
    });
    window.addEventListener('resize', () => {
      if (!mobile.matches) close();
      else if (isOpen()) position();
    });
    window.addEventListener('scroll', () => {
      if (isOpen()) position();
    }, {passive: true});
    // Keep the menu aligned when the announcement bar or header changes size.
    const layoutObserver = new ResizeObserver(() => {
      if (isOpen()) position();
    });
    layoutObserver.observe(document.body);
    layoutObserver.observe(bar);
    layoutObserver.observe(navigation.closest('.site-header'));
    window.addEventListener('pageshow', () => close());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
